import styled from "styled-components"

export const LinkStyledButton = styled.button`
  font-size: 16px;
  font-weight: 400;
  line-height: 28px;
  text-decoration: underline;
  color: var(--black);
`
